<template>
  <div style="width: 100%" v-if="serie.targetScoringDefinition.length > 0">
    <v-dialog v-model="showDeleteError" width="400">
      <v-card class="error-dialog">
        <v-card-title>Error</v-card-title>
        <v-card-text
          >You cannot delete a scoring convert zone if it is used in the
          approval criteria.</v-card-text
        >
      </v-card>
    </v-dialog>

    <v-toolbar color="grey lighten-3">
      <v-toolbar-title>Scoring convert</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn small fab color="primary" @click="onAddScoringConvert()">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <v-expansion-panels>
      <v-expansion-panel
        v-for="(scoring, index) in serie.targetScoringDefinition[0]
          .scoringConvert"
        :key="index"
      >
        <v-expansion-panel-header>
          <template>
            <v-fade-transition leave-absolute>
              <v-row no-gutters align="center">
                <v-col cols="11">
                  <v-chip small color="primary">
                    {{ scoring.name }}
                  </v-chip>
                </v-col>
                <v-col cols="1">
                  <v-btn icon>
                    <v-icon @click="deleteScoringConvert(index)"
                      >mdi-close-thick</v-icon
                    >
                  </v-btn>
                </v-col>
              </v-row>
            </v-fade-transition>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="scoring.name"
                  label="name"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-toolbar color="grey lighten-3">
              <v-toolbar-title>HitZone</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn small fab color="primary" @click="onAddHitZone(index)">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-toolbar>
            <v-expansion-panels>
              <v-expansion-panel
                v-for="(
                  hitZoneConvert, hitZoneConvertIndex
                ) in scoring.hitZoneConvert"
                :key="hitZoneConvertIndex"
              >
                <v-expansion-panel-header>
                  <template>
                    <v-fade-transition leave-absolute>
                      <v-row no-gutters align="center">
                        <v-col cols="11">
                          <v-chip small color="primary">
                            {{ hitZoneConvert.name }}
                          </v-chip>
                        </v-col>
                        <v-col cols="1">
                          <v-btn icon>
                            <v-icon
                              @click="
                                deleteHitZoneConvert(index, hitZoneConvertIndex)
                              "
                              >mdi-close-thick</v-icon
                            >
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-fade-transition>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-text-field
                    v-model="hitZoneConvert.name"
                    label="name"
                  ></v-text-field>
                  <span>From</span>
                  <v-text-field
                    v-model="hitZoneConvert.from.text"
                    label="text"
                  ></v-text-field>
                  <span>To</span>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="hitZoneConvert.to.text"
                        label="text"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model.number="hitZoneConvert.to.value"
                        type="number"
                        label="value"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <div style="width: 100%" v-else>
    Please pick a target scoring template in order to create scoring converts
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
export default {
  name: 'EditSeriesScoringConvert',
  apollo: {
    $client: 'shootingProgramClient',
  },
  props: {
    serie: Object,
  },
  data: () => ({
    showDeleteError: false,
  }),
  methods: {
    deleteHitZoneConvert(scoringConvertIndex, hitZoneConvertIndex) {
      const hitZoneConvert =
        this.serie.targetScoringDefinition[0]?.scoringConvert[
          scoringConvertIndex
        ]?.hitZoneConvert[hitZoneConvertIndex];
      if (!hitZoneConvert) return;

      // Check if any convert hit zones are used in the approval criteria before allowing to delete
      if (this.isZoneInUse(hitZoneConvert)) {
        this.showDeleteError = true;
        return;
      }

      this.serie.targetScoringDefinition[0].scoringConvert[
        scoringConvertIndex
      ].hitZoneConvert.splice(hitZoneConvertIndex, 1);
    },
    deleteScoringConvert(index) {
      const scoringConvert =
        this.serie.targetScoringDefinition[0].scoringConvert[index];
      if (!scoringConvert) return;

      // Check if any convert hit zones are used in the approval criteria before allowing to delete
      for (const hitZoneConvert of scoringConvert.hitZoneConvert) {
        if (this.isZoneInUse(hitZoneConvert)) {
          this.showDeleteError = true;
          return;
        }
      }

      this.serie.targetScoringDefinition[0].scoringConvert.splice(index, 1);
    },
    isZoneInUse(hitZoneConvert) {
      return this.serie.approval.criteria.some((criteria) => {
        return criteria.validZones.some((validZone) => {
          return validZone.id === hitZoneConvert.id;
        });
      });
    },
    onAddScoringConvert() {
      if (!this.serie.targetScoringDefinition[0].id) {
        this.serie.targetScoringDefinition =
          this.serie.targetScoringDefinition.map((targetScoring) => {
            return {
              id: targetScoring,
              scoringConvert: [],
            };
          });
      }
      if (!this.serie.targetScoringDefinition[0].scoringConvert) {
        this.serie.targetScoringDefinition[0].scoringConvert = [];
      }
      this.serie.targetScoringDefinition[0].scoringConvert.push({
        id: uuidv4(),
        name: '',
        hitZoneConvert: [],
      });
    },
    onAddHitZone(index) {
      if (
        !this.serie.targetScoringDefinition[0].scoringConvert[index]
          .hitZoneConvert
      ) {
        this.serie.targetScoringDefinition[0].scoringConvert[
          index
        ].hitZoneConvert = [];
      }
      this.serie.targetScoringDefinition[0].scoringConvert[
        index
      ].hitZoneConvert.push({
        id: uuidv4(),
        name: '',
        from: {
          text: '',
        },
        to: {
          text: '',
          value: 0,
        },
      });
    },
  },
};
</script>

<style scoped>
.error-dialog {
  max-width: 400px;
  background-color: rgb(247, 85, 85);
}
</style>
